import template from './query-variables-form.html';
import controller from './query-variables-form.controller';
import './query-variables-form.scss';

export default {
	controller,
	template,
	bindings: {
		tab: '<',
	},
	require:  {
		editor: '^^queryEditor',
	},
};
